<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn flat :loading="loading" v-on="on">
        <v-avatar color="red" size="35px" class="whoami--avatar" v-if="!loading">
          <span class="white--text" style="font-size: 20px; font-weight: 400;">{{user.username[0]}}</span>
        </v-avatar>
        <template v-if="!loading">{{user.username}}</template>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile :href="logoutURL">
        <v-list-tile-title>Logout</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import {mapState} from 'vuex'
import {authURL} from '@/api/index.js'
export default {
  computed: {
    ...mapState(['user']),
    loading () {
      return this.user === null
    },
    logoutURL () {
      return `${authURL}/logout`
    }
  }
}
</script>

<style>
.whoami--avatar {
  margin-right: 5px;
}
</style>
